<template>
  <div class="flex-v-center">
    <div class="loader-container">
      <b-loading
        v-if="isLoadingData"
        class="form-loader"
        :is-full-page="false"
        v-model="isLoadingData"
      />
    </div>
    <div class="is-multistep-form">
      <b-collapse
        class="is-collapse"
        animation="fade"
        :open="isOpen == 0"
        @open="isOpen = 0"
        @close="isOpen = 1"
      >
        <template #trigger="props">
          <div
            v-if="!props.open"
            :disabled="isLoadingData"
            @click="selectedCategory = ''"
            class="is-inline-flex"
          >
            <h2
              class="subtitle is-4 is-uppercase is-primary-alt has-text-weight-bold mb-0"
            >
              {{
                $i18n.locale === "en"
                  ? selectedCategory.nameEn
                  : selectedCategory.name
              }}
            </h2>
            <b-icon
              icon="fas fa-edit"
              size="is-medium"
              type="is-primary-alt pb-2 ml-2"
            />
          </div>
        </template>
        <div class="content">
          <b-select
            class="is-custom-select"
            :placeholder="$t('contribute.form.selectCategory')"
            rounded
            v-model="selectedCategory"
          >
            <option
              :selected="selectedCategory"
              :value="resident"
              v-for="(resident, id) in residents"
              :key="id"
            >
              {{ $i18n.locale === "en" ? resident.nameEn : resident.name }}
            </option>
          </b-select>
        </div>
      </b-collapse>
      <b-collapse
        class="is-collapse"
        animation="slide"
        :open="isOpen == 1"
        @open="isOpen = 1"
        @close="isOpen = 0"
      >
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
          <form class="form" @submit.prevent="handleSubmit(submitRequest)">
            <section class="columns my-3">
              <div class="column is-4">
                <ValidationProvider
                  rules="required|min:2"
                  v-slot="{ errors }"
                  class="form__element"
                >
                  <b-field
                    :message="errors[0]"
                    class="is-custom-field"
                    :label="$t('contribute.form.firstName.label')"
                  >
                    <b-input
                      :disabled="isLoadingData"
                      type="text"
                      class="is-custom-input"
                      :placeholder="$t('contribute.form.firstName.placeholder')"
                      v-model="submission.firstName"
                    />
                  </b-field>
                </ValidationProvider>

                <ValidationProvider
                  rules="required|min:2"
                  v-slot="{ errors }"
                  class="form__element"
                >
                  <b-field
                    :message="errors[0]"
                    class="is-custom-field"
                    :label="$t('contribute.form.lastName.label')"
                  >
                    <b-input
                      :disabled="isLoadingData"
                      type="text"
                      class="is-custom-input"
                      :placeholder="$t('contribute.form.lastName.placeholder')"
                      v-model="submission.lastName"
                    />
                  </b-field>
                </ValidationProvider>

                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors }"
                  class="form__element"
                >
                  <b-field
                    :message="errors[0]"
                    class="is-custom-field"
                    :label="$t('contribute.form.email.label')"
                  >
                    <b-input
                      :disabled="isLoadingData"
                      type="email"
                      :placeholder="$t('contribute.form.email.placeholder')"
                      class="is-custom-input"
                      v-model="submission.email"
                    />
                  </b-field>
                </ValidationProvider>

                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  class="form__element is-hidden"
                >
                  <b-field
                    :message="errors[0]"
                    class="is-custom-field"
                    :label="$t('contribute.form.category.label')"
                    hidden
                  >
                    <b-select
                      class="is-custom-select"
                      :placeholder="$t('contribute.form.category.placeholder')"
                      rounded
                      v-model="selectedCategory"
                      disabled
                    >
                      <option
                        :value="resident"
                        v-for="(resident, id) in residents"
                        :key="id"
                      >
                        {{ resident.name }}
                      </option>
                    </b-select>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="column">
                <ValidationProvider
                  rules="required|min:10|max:1000"
                  v-slot="{ errors }"
                  class="form__element"
                >
                  <b-field
                    :message="errors[0]"
                    class="is-custom-text-field"
                    :label="$t('contribute.form.message.label')"
                  >
                    <b-input
                      :disabled="isLoadingData"
                      type="textarea"
                      class="is-custom-textarea"
                      :placeholder="$t('contribute.form.message.placeholder')"
                      minlength="10"
                      maxlength="1000"
                      v-model="submission.message"
                    />
                  </b-field>
                </ValidationProvider>
                <!-- <ValidationProvider v-slot="{ errors }" class="form__element">
                  <b-field
                    label="Carica file"
                    :message="errors[0]"
                    class="is-custom-file"
                  >
                    <b-upload
                      class="is-custom-upload"
                      v-model="dropFile"
                      :disabled="dropFile || isLoadingData"
                      v-if="!dropFile"
                      accept=".PDF"
                      drag-drop
                      expanded
                    >
                      <div
                        class="my-2 has-text-centered is-subtle flex-v-center"
                      >
                        <p>
                          <b-icon
                            icon="fas fa-file-upload"
                            size="is-medium"
                          ></b-icon>
                        </p>
                        <p>Carica un file</p>
                        <p class="is-size-7">Massimo 1 file, formato .PDF</p>
                      </div>
                    </b-upload>
                  </b-field>
                  <div class="tags">
                    <b-tag
                      v-if="dropFile"
                      :disabled="isLoadingData"
                      class="is-primary"
                    >
                      {{ dropFile.name }}
                      <b-button
                        class="button delete is-rounded"
                        @click="deleteDropFile()"
                      ></b-button>
                    </b-tag>
                  </div>
                </ValidationProvider> -->
              </div>
            </section>
            <section class="columns is-cta">
              <div class="column">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  class="form__element"
                >
                  <b-field
                    :message="errors[0]"
                    class="is-custom-text-field"
                    label="Newsletter"
                  >
                    <div class="flex-h-start">
                      <b-checkbox
                        class="is-custom-input mr-0"
                        v-model="submission.acceptsMarketing"
                      />
                      <span class="newsletter-label has-text-weight-normal">
                        {{ $t("contribute.form.subscribe") }}</span
                      >
                    </div>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="column is-2">
                <b-button
                  :disabled="
                    invalid || isLoadingData || !submission.acceptsMarketing
                  "
                  :loading="isLoadingData"
                  :icon-left="isLoadingData ? '' : 'fas fa-paper-plane'"
                  class="is-pulled-right primary-btn"
                  native-type="submit"
                >
                  {{ isLoadingData ? "" : $t("contribute.form.submit") }}
                </b-button>
                <!-- </button> -->
              </div>
            </section>
          </form>
        </ValidationObserver>
        <!-- {{ this.mutableContact ? this.mutableContact : "nope" }} -->
      </b-collapse>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// .control .input,
// .control .select select {
//   border-radius: 1.35em;
// }

.form-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 500px;
  z-index: 1;
}

.loader-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.is-collapse {
  width: 100%;
}

.is-collapse-header {
  margin: 1em;
}

.is-flex {
  width: 100%;
  justify-content: space-between;
  flex-direction: row;

  align-items: center;
}

.is-cta {
  min-height: 120px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.is-flex-end {
  // width: 100%;
  // justify-content: flex-end;
  // flex-direction: column;
  text-align: right;
  // align-items: center;
}

.is-custom-file {
  // margin: 1em;
}

@media (min-width: 960px) {
  .is-multistep-form {
    margin: 2em 0;
    width: 768px;
  }
}

@media (max-width: 960px) {
  .is-multistep-form {
    width: 100%;
    // min-width: 600px;
  }
}
</style>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { email, max, min, oneOf, required } from "vee-validate/dist/rules";
import internalMailBody from "~/assets/mailtrap-template/internalTemplate.js";
import outboundMailBody from "~/assets/mailtrap-template/outboundTemplate.js";
import { apiBaseName, gql } from "~/utils/gql";

const GET_RESIDENTS = /* GraphQL */ `
  query GetResidents {
    allResidenti {
      name
      nameEn
      email
      id
      identifier
    }
  }
`;
const CREATE_SUBMISSION = /* GraphQL */ `
  mutation AddContact(
    $firstName: String!
    $lastName: String!
    $email: String!
    $category: ResidenteRelateToOneInput!
    $message: String!
    $acceptsMarketing: Boolean!
  ) {
    createContatto(
      data: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        category: $category
        message: $message
        acceptsMarketing: $acceptsMarketing
      }
    ) {
      id
      firstName
      lastName
      email
      category {
        name
      }
      message
      acceptsMarketing
    }
  }
`;

extend("required", {
  ...required,
  message: "Campo richiesto",
});

extend("min", {
  ...min,
  message: "Minimo caratteri: {length}",
});

extend("max", {
  ...max,
  message: "Minimo caratteri: {length}",
});

extend("email", {
  ...email,
  message: "Indirizzo e-mail non valido.",
});

extend("oneOf", {
  ...oneOf,
  message: "Paese non valido",
});

export default {
  name: "ContactForm",
  data() {
    return {
      isOpen: this.mutableOpen,
      selectedCategory: null,
      isLoadingData: false,
      // selectedCategoryId: this.submission.departmentId,
      radio: "default",
      firstName: "Test",
      lastName: "test",
      residents: {},
      dropFile: null,

      // fileUpload: {name: "testFile"},
    };
  },
  props: {
    mutableOpen: { type: Number, default: 0 },
    submission: {
      type: Object,
      default: () => ({
        id: undefined,
        firstName: "",
        lastName: "",
        email: "",
        department: {},
        // departmentId: null,
        message: "",
        file: "",
        acceptsMarketing: false,
      }),
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  watch: {
    selectedCategory: function (newVal, oldVal) {
      // watch it
      // console.log("Prop changed: ", newVal, " | was: ", oldVal);
      // console.log(this.selectedCategory);

      return (this.isOpen = 1);
    },
  },
  // created() {

  // },

  mounted() {
    this.asyncData();
  },
  computed: {},
  methods: {
    async asyncData() {
      this.isLoadingData = true;
      const { data } = await gql(GET_RESIDENTS);
      this.residents = data.allResidenti;
      this.isLoadingData = false;
    },
    async sendMail() {
      try {
        let submissionDate = new Date().toLocaleString("it-IT", {
          timeZone: "Europe/Rome",
        });

        if (this.selectedCategory.identifier === "info") {
          await this.$axios.$post(`${apiBaseName}/api/forward`, {
            headers: {
              "Content-Type": "application/json",
            },
            mailHeaders: {
              "X-MT-Category": "contact-form-forward",
            },
            to: this.selectedCategory.email,
            fromName: `${this.submission.firstName} ${this.submission.lastName} via TDF*P`,
            subject: `🏛️ Richiesta di contatto da ${this.submission.firstName} ${this.submission.lastName}`,
            text: `[TEMPIO DEL FUTURO *PERDUTO]
                    HTTPS://WWW.TEMPIODELFUTURO.ART/

                    Nuova richiesta di contatto
 
                    ----

                    📅 ${submissionDate}
                    Da: 📫 [${this.submission.firstName} ${
              this.submission.lastName
            }] <${this.submission.email}>
                    Categoria: ${this.selectedCategory.name}
                    Messaggio originale:

                    "${this.submission.message}"
 
                    ----

                    ${new Date().getFullYear()} &copy; TDF*P
                    Questa e-mail è generata automaticamente. Non rispondere a questo messaggio.

                    [Facebook]
                    https://www.facebook.com/tempiodelfuturoperduto
                    [Instagram]
                    https://www.instagram.com/tempiodelfuturoperduto
                    [PRIVACY]
                    https://www.tempiodelfuturo.art/privacy`,
            html: internalMailBody(
              `${this.submission.firstName} ${this.submission.lastName}`,
              this.submission.email,
              this.submission.message,
              submissionDate,
              this.selectedCategory.name
            ),
          });
        } else {
          await this.$axios.$post(`${apiBaseName}/api/forward`, {
            headers: {
              "Content-Type": "application/json",
            },
            mailHeaders: {
              "X-MT-Category": "contact-form-forward",
            },
            to: this.selectedCategory.email,
            from: {
              name: `${this.submission.firstName} ${this.submission.lastName} via TDF*P`,
              address: "noreply@tempiodelfuturo.art",
            },
            subject: `🏛️ Richiesta di contatto da ${this.submission.firstName} ${this.submission.lastName}`,
            text: `[TEMPIO DEL FUTURO *PERDUTO]
                    HTTPS://WWW.TEMPIODELFUTURO.ART/

                    Nuova richiesta di contatto
 
                    ----

                    📅 ${submissionDate}
                    Da: 📫 [${this.submission.firstName} ${
              this.submission.lastName
            }] <${this.submission.email}>
                    Categoria: ${this.selectedCategory.name}
                    Messaggio originale:

                    "${this.submission.message}"
 
                    ----

                    ${new Date().getFullYear()} &copy; TDF*P
                    Questa e-mail è generata automaticamente. Non rispondere a questo messaggio.

                    [Facebook]
                    https://www.facebook.com/tempiodelfuturoperduto
                    [Instagram]
                    https://www.instagram.com/tempiodelfuturoperduto
                    [PRIVACY]
                    https://www.tempiodelfuturo.art/privacy`,

            //     html: `<p>Nuovo contatto del ${submissionDate} da <a href="mailto:${this.submission.email}">${this.submission.firstName} ${this.submission.lastName}</a></p>
            //   <p>Questa è una e-mail automatizzata. Non rispondere a questo messaggio. Utilizza il link per rispondere.</p>
            //   <p>Messaggio originale: <span style="font-family: Monospace;">"${this.submission.message}"</span></p>
            //     `,
            html: internalMailBody(
              `${this.submission.firstName} ${this.submission.lastName}`,
              this.submission.email,
              this.submission.message,
              submissionDate,
              this.selectedCategory.name
            ),
          });
          await this.$axios.$post(`${apiBaseName}/api/forward`, {
            headers: {
              "Content-Type": "application/json",
            },
            mailHeaders: {
              "X-MT-Category": "contact-form-forward-internal",
            },
            to: "hello@tempiodelfuturo.art",
            fromName: `${this.submission.firstName} ${this.submission.lastName} via TDF*P`,
            subject: `↩️ FWD: ${this.selectedCategory.name} \u2013 🏛️ Richiesta di contatto da ${this.submission.firstName} ${this.submission.lastName}`,
            text: `[TEMPIO DEL FUTURO *PERDUTO]
                    HTTPS://WWW.TEMPIODELFUTURO.ART/

                    Nuova richiesta di contatto
 
                    ----

                    📅 ${submissionDate}
                    Da: 📫 [${this.submission.firstName} ${
              this.submission.lastName
            }] <${this.submission.email}>
                    Categoria: ${this.selectedCategory.name}
                    Messaggio originale:

                    "${this.submission.message}"
 
                    ----

                    ${new Date().getFullYear()} &copy; TDF*P
                    Questa e-mail è generata automaticamente. Non rispondere a questo messaggio.

                    [Facebook]
                    https://www.facebook.com/tempiodelfuturoperduto
                    [Instagram]
                    https://www.instagram.com/tempiodelfuturoperduto
                    [PRIVACY]
                    https://www.tempiodelfuturo.art/privacy`,

            //     html: `<p>Nuovo contatto del ${submissionDate} da <a href="mailto:${this.submission.email}">${this.submission.firstName} ${this.submission.lastName}</a></p>
            //   <p>Questa è una e-mail automatizzata. Non rispondere a questo messaggio. Utilizza il link per rispondere.</p>
            //   <p>Messaggio originale: <span style="font-family: Monospace;">"${this.submission.message}"</span></p>
            //     `,
            html: internalMailBody(
              `${this.submission.firstName} ${this.submission.lastName}`,
              this.submission.email,
              this.submission.message,
              submissionDate,
              this.selectedCategory.name
            ),
          });
        }

        await this.$axios
          .$post("/api/send", {
            headers: {
              "Content-Type": "application/json",
            },
            mailHeaders: {
              "X-MT-Category": "contact-form-request",
            },
            to: `${this.submission.firstName} ${this.submission.lastName} <${this.submission.email}>`,
            subject: `Grazie per averci contattato`,

            text: `[TEMPIO DEL FUTURO *PERDUTO]
                    HTTPS://WWW.TEMPIODELFUTURO.ART/


                    Abbiamo ricevuto la tua richiesta

                    Ciao ${
                      this.submission.firstName
                    }, grazie per averci contattato! Ti risponderemo al più presto.

                    ----
                    
                    Messaggio originale

                    Data e ora: ${submissionDate}
                    Categoria: ${this.selectedCategory.name} 

                    "${this.submission.message}"
                   
                    ----

                    ${new Date().getFullYear()} &copy; TDF*P
                    Questa e-mail è generata automaticamente. Non rispondere a questo messaggio.

                    [Facebook]
                    https://www.facebook.com/tempiodelfuturoperduto
                    [Instagram]
                    https://www.instagram.com/tempiodelfuturoperduto
                    [PRIVACY]
                    https://www.tempiodelfuturo.art/privacy`,
            html: outboundMailBody(
              this.submission.firstName,
              this.submission.message,
              submissionDate,
              this.selectedCategory.name
            ),
          })
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
        this.$store.commit(
          "setSubmission",
          true
          // { root: true }
        );
        this.isLoadingData = false;

        this.$router.push("/thankyou");
        // console.log(mailBody);
      } catch (e) {
        console.error(e);
      } finally {
        // console.log("done");
        // this.isLoadingData = false;
      }
    },

    async submitRequest() {
      this.isLoadingData = true;

      try {
        if (this.submission.email.includes("tempiodelfuturo.art")) {
          this.$store.commit(
            "setSubmission",
            true
            // { root: true }
          );
          this.$router.push("/thankyou");
          this.isLoadingData = false;
        } else {
          const { data } = await gql(CREATE_SUBMISSION, {
            firstName: this.submission.firstName,
            lastName: this.submission.lastName,
            email: this.submission.email,
            message: this.submission.message,
            acceptsMarketing: this.submission.acceptsMarketing,
            category: {
              connect: {
                id: this.selectedCategory.id,
              },
            },
            // files: this.dropFile,
          });
          this.contact = data.createContatto;
          // this.emailSent = await this.sendMail();
          this.sendMail();
        }
        // console.log(data.createContatto);        }
        // create submission for back-end
      } catch (e) {
        console.error(e);
        // this.isLoadingData = true;
      } finally {
      }

      // console.log(this.contact);
    },

    deleteDropFile() {
      this.dropFile = null;
    },
  },
  setup(props, { emit }) {
    const form = props.submission;

    const submitForm = () => {
      emit("submit", {
        form,
        onComplete: () => {},
        // TODO: Handle Error
        onError: () => {},
      });
    };

    return {
      form,
      submitForm,
    };
  },
};
</script>
